module.exports = __webpack_public_path__ + "img/img (11).d11730bd.jpg";